import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { getUserById } from '../../api/user';

const SubscriptionSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Poll for subscription status update
    const checkSubscriptionStatus = async () => {
      const userId = localStorage.getItem('userId');
      if (userId) {
        try {
          const user = await getUserById();
          if (user.subscriptionStatus !== 0) {
            // Not NO_SUBSCRIPTION
            // Status updated, redirect to main app
            setTimeout(() => {
              navigate('/');
            }, 2000);
          }
        } catch (error) {
          console.error('Error checking subscription status:', error);
        }
      }
    };

    // Check every 2 seconds
    const interval = setInterval(checkSubscriptionStatus, 2000);

    // Countdown timer
    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
      clearInterval(countdownInterval);
    };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-grey flex items-center justify-center">
      <div className="text-center">
        <div className="mb-8">
          <CheckCircleIcon className="w-24 h-24 text-green-400 mx-auto animate-pulse" />
        </div>

        <h1 className="text-4xl font-bold text-white mb-4">
          Welcome to Superpower Social!
        </h1>

        <p className="text-xl text-white text-opacity-80 mb-8">
          Your subscription is being activated...
        </p>

        <div className="mb-8">
          <div className="inline-flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-violet mr-3"></div>
            <span className="text-white">Processing your subscription</span>
          </div>
        </div>

        <p className="text-sm text-white text-opacity-60">
          Redirecting to the app in {countdown} seconds...
        </p>

        <button
          onClick={() => navigate('/')}
          className="mt-6 text-violet hover:text-violet-light underline"
        >
          Go to app now
        </button>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
